import { FC } from "react";
import { Link, useParams } from "react-router";

import LegitimateIcon from "@/assets/logos/LogoSymbol.svg?react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CMSTabs } from "@/components/web-experience/cms-tabs";

export const Content: FC = () => {
  const { skuId } = useParams<{ skuId: string }>();

  return (
    <div className="flex-1 border-x p-8 overflow-y-scroll">
      <h3 className="text-2xl font-medium mb-4">Content</h3>
      <Alert className="mb-6 bg-muted">
        <LegitimateIcon className="size-4" />
        <AlertTitle className="text-base">Legitimate</AlertTitle>
        <AlertDescription className="text-sm">
          <p>
            You've chosen to build your webpage using Legitimate. To change
            this, go{" "}
            <Link to={`/skus/${skuId}/webpage`} className="underline">
              back to the SKU page
            </Link>
            .
          </p>
        </AlertDescription>
      </Alert>
      <CMSTabs />
    </div>
  );
};
